import React from "react";
import MainSection from "../components/MainSection";
import ServicesContentContainer from "../components/ServicesContentContainer";

const Ap = () => {
  const contentData = [
    {
      id: 1,
      title: "Initial Consultation",
      description:
        "The first step is a comprehensive consultation where we get to understand your educational goals, interests, and potential challenges. This involves a detailed discussion about your academic history, career ambitions, and preferred study destinations. Our experts use this information to provide personalized guidance and advice.",
    },
    {
      id: 2,
      title: "Course and University Selection",
      description:
        "Based on your academic profile and preferences, we'll guide you through the process of course and university selection. Our extensive knowledge of global education opportunities ensures you have a range of quality choices. We'll provide you with detailed information on universities, courses, admission requirements, and tuition fees, among other things, to assist you in making an informed decision.",
    },
    {
      id: 3,
      title: "Application Preparation",
      description:
        "This is one of the most crucial steps. Once you've decided on your preferred course and university, the next step involves preparing your application. We provide step-by-step guidance on how to correctly fill out your application forms, write compelling personal statements, and prepare other essential documents. Our experts will review your application in detail to ensure it is error-free and presents your profile effectively.",
    },
    {
      id: 4,
      title: "Submission and Follow-up",
      description:
        "Upon completion of your application, we guide you through the submission process to ensure that all details are correctly and timely submitted. But our work doesn’t stop there – we closely follow up with your chosen universities on the status of your application, keeping you informed at every stage of the process.",
    },
    {
      id: 5,
      title: "Application Outcome",
      description:
        "Once the university makes a decision on your application, we are here to help interpret the results. If your application is successful, we guide you on the next steps towards enrollment. In the event of a rejection, we analyze the reasons and provide recommendations for alternative courses or universities, or advise on improving your application for the next intake.",
    },
    {
      id: 6,
      title: "Appeals and Reapplications",
      description:
        "If required, we assist with appeals or reapplications to universities. We provide guidance on improving your application, addressing the reasons for rejection, and enhancing your appeal or reapplication to increase your chances of acceptance.",
    },
    {
      id: 7,
      title: "Final Enrollment",
      description:
        "Once your admission is secured, we guide you through the final enrollment process. This includes understanding and completing enrollment documentation, payment of tuition fees, and understanding your course schedule and commencement details.",
    },
  ];
  const conclusion =
    "Please remember, our team is dedicated to ensuring a smooth, hassle-free application process for you, from the initial consultation to final enrollment.";
  return (
    <>
      <MainSection bannerTxt="APPLICATION PROCESS" color="gray" />
      <ServicesContentContainer
        contentData={contentData}
        conclusion={conclusion}
        title={"Application Processes"}
        includeTxt={""}
      />
    </>
  );
};

export default Ap;
